<template>
  <div>
    <nav-bar></nav-bar>
    <div class="training container">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul v-if="client">
            <li><a @click="$router.push('/training', $router.go())">{{ CONSTANTS.getCopy('TRAINING_BREADCRUMBS_TRAINING') }}</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{clientName}}</a></li>
          </ul>
          <ul v-else>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('TRAINING_BREADCRUMBS_TRAINING') }}</a></li>
          </ul>
        </nav>
        <div class="training-filter">
          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('TRAINING_FIELDS_TYPE') }}</label>
            <div class="control">
              <div class="select">
                <select v-model="typeTraining" @change="getTraining">
                  <option v-for="element in types" :key="element.idTypeTrainning" :value="element.idTypeTrainning">
                    {{element.typeTrainning}}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label">{{ CONSTANTS.getCopy('TRAINING_FIELDS_REVISED') }}</label>
            <div class="control">
              <div class="select">
                <select v-model.number="revised">
                  <option value=-1>{{ CONSTANTS.getCopy('TRAINING_FIELDS_REVISED_ALL') }}</option>
                  <option value=0>{{ CONSTANTS.getCopy('TRAINING_FIELDS_REVISED_NO') }}</option>
                  <option value=1>{{ CONSTANTS.getCopy('TRAINING_FIELDS_REVISED_YES') }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="button is-primary is-left" @click="getTraining">
            <span class="icon"><i class="fas fa-sync-alt"></i></span>
            <span class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_UPDATE_BUTTON') }}</span>
          </div>
          <div class="button is-primary is-left" v-if="trainingsSelected.length > 0" @click="checkClient">
            <span class="icon"><i class="fas fa-search"></i></span>
            <span class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_UPDATE_REVIEW') }}</span>
          </div>
        </div>

        <!-- input  -->
        <div class="control is-expanded">
          <input class="input" type="text" v-bind:placeholder="CONSTANTS.getCopy('TRAINING_SEARCH_MSG_PLACEHOLDER')"
                 v-model="textFilter"
                 v-on:keyup.esc="textFilter=null">
        </div>

        <br><br>
        <div class="training container" style="overflow: scroll">
        <table class="table is-striped is-fullwidth">

          <thead>
          <tr>
            <th class="is-capitalized">
              <div class="is-flex">
                <input type="checkbox" ref="select-all" id="select-all" @change="selectAllTrainings">
                <label class="pleft-1" for="select-all">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_SELECT_INPUT') }}</label>
              </div>

            </th>
            <th class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_TYPE') }}</th>
            <th class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_CHATBOT') }}</th>
            <th class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_NAME') }}</th>
            <th class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_INTENT') }}</th>
            <th class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_PHRASE') }}</th>
            <th class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_MSG') }}</th>
            <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_REVIEWED') }}</th>
            <th class="is-capitalized">{{ CONSTANTS.getCopy('TRAINING_TABLE_HEADER_DATE') }}</th>
            <th class="table-button-column"></th>
          </tr>
          </thead>

          <tbody>
          <tr v-for="training in filteredTrainings" v-if="revised === -1 || training.revised === revised" :key="training.idTrainning">
            <td>
              <div class="field has-addons">
                <p class="control">
                  <a class="button no-border" v-if="!isSelected(training.idTrainning)" v-bind:title="CONSTANTS.getCopy('TRAINING_TABLE_BODY_SELECT')"
                     @click="selectTraining(training.idTrainning)">
                    <span class="icon"><i class="fas fa-check"></i></span>
                  </a>
                  <a class="button is-primary" v-else v-bind:title="CONSTANTS.getCopy('TRAINING_TABLE_BODY_UNSELECT')" @click="unselectTraining(training.idTrainning)">
                    <span class="icon"><i class="fas fa-check"></i></span>
                  </a>
                </p>
              </div>
            </td>
            <td>{{training.typeName}}</td>
            <td>{{training.client}}</td>
            <td>{{training.userName}}</td>
            <td>{{training.intent}}</td>
            <td>{{training.term}}</td>
            <td style="max-width: 150px">{{training.message}}</td>
            <td class="has-text-centered">
              <span v-if="training.revised === 1" class="icon has-text-success">
                <i class="fas fa-check"></i>
              </span>
              <span v-if="training.revised === 2" class="icon has-text-danger">
                <i class="fas fa-times"></i>
              </span>
            </td>
            <td>{{training.date}}</td>
            <td>
              <div class="field has-addons">
                <p class="control">
                  <a @click="addKeywords(training)"
                     class="button is-warning"
                     v-bind:title="CONSTANTS.getCopy('TRAINING_TABLE_BODY_ADD_KEYWORD')">
                    <span class="icon"><i class="fas fa-edit"></i></span>
                  </a>
                </p>
                <p class="control">
                  <a @click="checkClient(training)"
                     class="button is-primary"
                     v-bind:title="CONSTANTS.getCopy('TRAINING_TABLE_BODY_REVIEW')">
                    <span class="icon"><i class="fas fa-search"></i></span>
                  </a>
                </p>
              </div>
            </td>
          </tr>
          </tbody>

        </table>
        </div>

        <nav v-if="!textFilter" class="pagination is-centered" role="navigation" aria-label="pagination">
          <a class="pagination-previous" @click="previousPage" :disabled="paginator.current === 0">{{ CONSTANTS.getCopy('TRAINING_LINK_PREVIOUS_PAGE') }}</a>
          <a class="pagination-next" @click="nextPage" :disabled="paginator.current >= paginator.total">{{ CONSTANTS.getCopy('TRAINING_LINK_NEXT_PAGE') }}</a>
          <ul class="pagination-list">
            <li v-for="page in paginator.total+1" :key="page">
              <a :class="page-1 === paginator.current ? 'pagination-link is-current' : 'pagination-link'"
                 @click="goPage(page-1)">
                {{page}}
              </a>
            </li>
          </ul>
        </nav>

      </div>
    </div>
  </div>
</template>

<script>
import Strings from '../../lib/Strings'
import Arrays from '../../lib/Arrays'
import CONSTANTS from '../../constants'

export default {
  data () {
    return {
      client: this.$route.params.client,
      clientName: 'Chatbot',
      textFilter: null,
      typeTraining: 0,
      revised: -1,
      types: {},
      trainings: [],
      paginatedTrainings: [],
      trainingsSelected: [],
      trainingsFilter: [],
      isSelectedAllOption: false,
      page: 0,
      paginator: {
        current: 0,
        total: 0,
        limit: 100
      }
    }
  },
  watch: {
    revised: function () {
      this.paginator.current = 0
      this.paginate()
    }
  },
  created () {
    this.getTypes()
    this.getTraining()
    this.breadcrumbDetails()
  },
  computed: {
    filteredTrainings () {
      let self = this

      if (!self.textFilter) {
        this.unselectAllTrainings()
        return this.paginatedTrainings
      }

      self.trainingsFilter = this.trainings.filter(function (training) {
        if (Strings.normalizeText(training.message).search(Strings.normalizeText(self.textFilter)) > -1) {
          return true
        }
      })
      if (self.trainingsSelected.length > 0) {
        let trainingsFilterSelected = []
        self.trainingsFilter.forEach((element) => {
          self.trainingsSelected.forEach((training) => {
            if (element.idTrainning === training[0]) trainingsFilterSelected.push([element.idTrainning])
          })
        })
        self.trainingsSelected = trainingsFilterSelected
      }
      return this.trainingsFilter
    }
  },
  methods: {
    breadcrumbDetails () {
      if (this.client) {
        this.api.post('/ClientById/', {idClient: this.client}).then(response => {
          this.clientName = response.client.name
        })
      }
    },
    getTraining () {
      this.api.post('/TrainningGetList', {type: this.typeTraining, idClient: this.client}).then(response => {
        this.trainings = response.trainnings
        this.paginator.current = 0
        this.paginate()
      })
    },
    getTypes () {
      this.api.post('/DataTypeTrainningList').then(response => {
        this.types = response.typesTrainning
        this.typeTraining = response.typesTrainning[0].idTypeTrainning
      })
    },
    addKeywords (training) {
      this.$router.push('/clients/' + training.idClient + '/training/' + training.idTrainning + '/keywords/' + training.idDictionary)
    },
    isSelected (training) {
      return Arrays.findElement(this.trainingsSelected, training)
    },
    selectTraining (training) {
      this.trainingsSelected.push([training])
    },
    unselectTraining (training) {
      this.trainingsSelected = this.trainingsSelected.filter(u => u[0] !== training)
    },
    selectAllTrainings () {
      if (!this.isSelectedAllOption) {
        let trainings = this.trainingsFilter.length > 0 ? this.trainingsFilter : this.paginatedTrainings
        trainings.forEach((training) => {
          this.trainingsSelected.push([training.idTrainning])
        })
      }
      if (this.isSelectedAllOption) {
        this.trainingsSelected = []
      }
      this.isSelectedAllOption = !this.isSelectedAllOption
    },
    checkClient (training = 0) {
      let message = CONSTANTS.getCopy('TRAINING_MARK_PHRASE_AS_REVIEWED')
      const okText = CONSTANTS.getCopy('TRAINING_REVIEW')
      const koText = CONSTANTS.getCopy('TRAINING_DISCARD')
      const koStyle = 'is-danger'
      let params = {idTrainning: training.idTrainning, listIdTrainning: null}
      if (this.trainingsSelected.length > 0) {
        message = CONSTANTS.getCopy('TRAINING_DISCARD_OR_REVIEW_PHRASE')
        let trainingsSelectedTemp = this.trainingsSelected.reduce((acc, curr) => acc.concat(curr), [])
        params = {idTrainning: null, listIdTrainning: trainingsSelectedTemp}
      }

      this.dialog.confirm({message, okText, koText, koStyle}).then(() => {
        this.api.post('/TrainningRevised', params).then(() => {
          if (this.trainingsSelected.length > 0) this.getTraining()
          if (this.trainingsSelected.length === 0) {
            this.trainings = this.trainings.map(training => ({
              ...training,
              revised: training.idTrainning === params.idTrainning ? 1 : training.revised
            }))
            this.paginate()
          }
        })
      }).catch(() => {
        this.api.post('/TrainningDiscard', params).then(() => {
          if (this.trainingsSelected.length > 0) this.getTraining()
          if (this.trainingsSelected.length === 0) {
            this.trainings = this.trainings.map(training => ({
              ...training,
              revised: training.idTrainning === params.idTrainning ? 2 : training.revised
            }))
            this.paginate()
          }
        })
      })
    },
    paginate () {
      const filter = this.revised === -1 ? this.trainings : this.trainings.filter(training => training.revised === this.revised)
      this.paginator.total = Math.floor(filter.length / this.paginator.limit)
      this.paginatedTrainings = filter.slice(
        this.paginator.current * this.paginator.limit,
        (this.paginator.current + 1) * this.paginator.limit)
    },
    nextPage () {
      if (this.paginator.current < this.paginator.total) {
        this.paginator.current++
        this.paginate()
        window.scrollTo(0, 0)
      }
    },

    previousPage () {
      if (this.paginator.current > 0) {
        this.paginator.current--
        this.paginate()
        window.scrollTo(0, 0)
      }
    },
    goPage (page) {
      this.paginator.current = page
      this.paginate()
      window.scrollTo(0, 0)
    },
    unselectAllTrainings () {
      this.trainingsFilter = []
      this.trainingsSelected = []
      this.isSelectedAllOption = false
      if (this.$refs['select-all']) this.$refs['select-all'].checked = false
    }
  }

}
</script>

<style>
  .training.container {
    max-width: 98vw !important;
  }
  .training-filter {
    display: flex;
    align-items: flex-end;
    gap: 40px;
    margin-bottom: 30px;
  }
  .training-filter .field {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Training/Training.vue